import { ApiService } from "./apiService";
import { ENDPOINTS } from "../config/apiConfig";

export interface RankingResult {
  competitorId: number;
  firstName: string;
  lastName: string;
  weightKg?: number | null;
  isAbsent?: boolean;
  totalFishCount: number;
  sectionId: number;
  sectionName: string;
  score: number;
  position: number;
  groupId?: number;
}

export interface RankingPayload {
  competitionId: number;
  sectionId: number;
  ranking: Array<{
    concorrenteId: number;
    position: number;
    catches?: number;
    score?: number;
  }>;
}

export interface RankingGroupResult {
  competitionId: number;
  sectionId: number;
  groupId: number;
  competitorIds: number[];
  fishCount: number;
  score: number;
  position: number;
}
export interface RankingGroupRequest {
  request: RankingGroupResult;
}

export interface CarpResultEntry {
  competitorId: number;
  weightKg: number | null;
  isAbsent: boolean;
  tieOrder: number | null;
}

export class ResultService {
  static getCarpResults(id: number): Promise<{ resultsPublished: boolean; results: CarpResultEntry[] }> {
    return ApiService.client.get(`/results/competitions/${id}/carp`);
  }
  static saveCarpResults(id: number, request: { publish: boolean; results: CarpResultEntry[]; addCompetitorIds?: number[] }): Promise<void> {
    return ApiService.client.put(`/results/competitions/${id}/carp`, request);
  }
  static async getRanking(competitionId: number): Promise<RankingResult[]> {
    return ApiService.client.get<RankingResult[]>(
      ENDPOINTS.RESULT.GET_RANKING(competitionId)
    );
  }
  static async saveRanking(payload: RankingPayload): Promise<void> {
    return ApiService.client.post<void>(
      ENDPOINTS.RESULT.SAVE_RANKING(payload.competitionId),
      payload
    );
  }

  static async saveGroupRanking(competitionId: number, requests: RankingGroupResult[]): Promise<void> {
    return ApiService.client.post<void>(
      ENDPOINTS.RESULT.SAVE_GROUP_RANKING(competitionId),
      requests
    );
  }
}
